import { render } from "./RightToWorkCheck.vue?vue&type=template&id=b97f3768&scoped=true&ts=true"
import script from "./RightToWorkCheck.vue?vue&type=script&lang=ts"
export * from "./RightToWorkCheck.vue?vue&type=script&lang=ts"

import "./RightToWorkCheck.vue?vue&type=style&index=0&id=b97f3768&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b97f3768"]])

export default __exports__